export const FileType = {
    EXCEL: 'EXCEL',
    GOOGLE: 'GOOGLE',
};

export const userType = {
    STEPS_BOT: 'STEPS_BOT'
}